const analyticsReportType = Object.freeze({
  all_channels: 1,
  journey_actions: 2,
  currently_waiting: 3
})

const analyticsReportTypeLabels = Object.freeze({
  1: 'Step_Report_Table_Column_Report_Type_All_Channels',
  2: 'Step_Report_Table_Column_Report_Type_Journey_Actions',
  3: 'Step_Report_Table_Column_Report_Type_Currently_Waiting'
})

export { analyticsReportType, analyticsReportTypeLabels }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/AnalyticsReportType.js